import styled from 'styled-components';

export const Overlay = styled.div`
  display: flex;
  align-items: ${({ isBigModal }) => (isBigModal ? 'flex-start' : 'center')};
  flex-wrap: wrap;
  justify-content: center;
  overflow-y: auto;
  position: fixed;
  z-index: 1299;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

export const ModalsBox = styled.div`
  overflow: visible;
  background: #fff;
  box-shadow: 0px 24px 18px rgba(23, 43, 77, 0.04), 0px 35px 24px rgba(23, 43, 77, 0.08);
  border-radius: 8px;
  margin: 60px;
`;
